import { connect } from 'react-redux';
import RightPanelComponent from '../components/RightPanelComponent';

const mapStateToProps = (state) => ({
  login: state.login,
  mapCurrencyMarkets: state.setting.mapCurrencyMarkets,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RightPanelComponent);
